const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { findActiveFilters } = require('utilities/filtersHelper');
// @ components
const EmitedTransfersContentFilters = require('./emitedTransfersContentFilters/emitedTransfersContentFilters');
const EmitedTransfersContentHeader = require('./emitedTransfersContentHeader/emitedTransfersContentHeader');
const EmitedTransfersContentTable = require('./emitedTransfersContentTable/emitedTransfersContentTable');
//@commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ actions
const intervenersActions = require('actions/getAccountInterveners');

class EmitedTransfersContent extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const {
            immAccount,
            requestInterveners
        } = this.props;
        requestInterveners(immAccount.get('accountId'));
    }

    componentWillReceiveProps(nextProps) {
        const {
            immAccount,
            requestInterveners,
            resetInterveners
        } = this.props;
        const currentAccountId = immAccount.get('accountId');
        const nextAccountId = nextProps.immAccount.get('accountId');

        if (currentAccountId !== nextAccountId) {
            resetInterveners(currentAccountId);
            requestInterveners(nextAccountId);
        }
    }

    componentWillUnmount() {
        const {
            immAccount,
            resetInterveners
        } = this.props;
        resetInterveners(immAccount.get('accountId'));
    }

    render() {
        const {
            immAccount,
            immAccounts,
            immEmitedTransfers,
            immFilter,
            immScreen,
            isInactiveAccountsEnabled,
            onResetFilter,
            onClearFilters,
            onFilterClick,
            onTransfersFetch,
            requestEmitedTransfersNextPage
        } = this.props;
        const accountId = immAccount.get('accountId');
        const immAccountEmitedTransfers = immEmitedTransfers.get(accountId);
        const hasFilters = findActiveFilters(immFilter);
        let filters;
        let content;

        if (immAccountEmitedTransfers) {
            if (hasFilters) {
                filters = (
                    <EmitedTransfersContentFilters
                        immFilter={immFilter}
                        onResetFilter={onResetFilter}
                        onClearFilters={onClearFilters}
                    />
                );
            }

            if (immAccountEmitedTransfers.get('loading')) {
                content = <LoadingSection />;
            } else if (!!immAccountEmitedTransfers.get('error')) {
                const retryButton = (
                    <OKButton onClick={onTransfersFetch}>
                        <FormattedText value="common-retry" />
                    </OKButton>
                );
                content = (
                    <EmptyState
                        button={retryButton}
                        iconType="nointernet-banking"
                        primaryText={formatText('common-lostConnection')}
                    />
                );
            } else if (immAccountEmitedTransfers.get('byOrder').size > 0) {
                content = (
                    <EmitedTransfersContentTable
                        accountId={accountId}
                        immAccountEmitedTransfers={immAccountEmitedTransfers}
                        immScreen={immScreen}
                        requestEmitedTransfersNextPage={requestEmitedTransfersNextPage}
                    />
                );
            } else {
                if (hasFilters) {
                    content = <EmptyState primaryText={formatText('transfersEmitted-hasFilterNoTransfersRetrieved')} iconType="transfer-banking"/>;
                } else {
                    content = (
                        <EmptyState
                            primaryText={formatText('transfersLanding-noEmitedTransfers')}
                            iconType="transfer-banking" />
                    );
                }
            }
        }

        return (
            <article className="emited-transfers-content">
                <EmitedTransfersContentHeader
                    accountId={accountId}
                    immAccounts={immAccounts}
                    immFilter={immFilter}
                    isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                    onFilterClick={onFilterClick}
                />
                {filters}
                {content}
            </article>
        );
    }
}

EmitedTransfersContent.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immEmitedTransfers: PropTypes.object.isRequired,
    immFilter: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    onResetFilter: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    onFilterClick: PropTypes.func.isRequired,
    onTransfersFetch: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    requestEmitedTransfersNextPage: PropTypes.func.isRequired,
    resetInterveners: PropTypes.func.isRequired
};

module.exports.constructor = EmitedTransfersContent;
module.exports.EmitedTransfersContent = connect(null, {
    requestInterveners: intervenersActions.requestAccountInterveners,
    resetInterveners: intervenersActions.resetAccountInterveners
})(EmitedTransfersContent);
